import {observer} from "mobx-react";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../components/fonts/font-props";
import Card from "../../../../../components/layouts/card/card";
import Table from "../../../../../components/table/table";
import CustomerCaseStore from "../../stores/customer-case-store";
import TableRow from "../../../../../components/table/components/table-row/table-row";
import { useState } from "react";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { TABLE_SPACING_VARIANT } from "../../../../../components/table/table.types";
import { CARD_SPACING_VARIANT } from "../../../../../components/layouts/card/card.types";
import TextTruncate from "../../../../../components/text-truncate/text-truncate";
import MediaWithPlaceholder, { MEDIA_VARIANTS } from "../../../../../components/media-with-placeholder/media-with-placeholder";
import Currency from "../../../../../components/currency/currency";
// TODO: While we created a separate component,
// we still need to reuse styles of rma-items-card - looking for a better way though
import '../rma-items-card/rma-items-card.scss';
import Icon from "../../../../../components/icons/icon/icon";
import IconReturnNotRefundExchange from "../../../../../components/icons/icon-return-not-refund-exchange/icon-return-not-refund-exchange";
import { ICON_SIZE } from "../../../../../components/icons/icon-props-interface";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import RmaNotZeroMoneyAmount from "../rma-not-zero-money-amount/rma-not-zero-money-amount";
import { TOOLTIP_PLACEMENTS } from "../../../../../components/tooltip/tooltip-box";
import { Tooltip, TOOLTIP_VARIANTS } from "../../../../../components/tooltip/tooltip";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";

interface IProps {
    customerCaseStore?: CustomerCaseStore;
    isLoading: boolean;
}

const RmaPageNewItemsCard: React.FC<IProps> = observer(({isLoading, customerCaseStore}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';

    const onExpandClick = (expanded: boolean) => {
        if (expanded) {
            rmsMixpanelStore.trackEvent("d&_new_items_dropdown");
        }
        setIsExpanded(expanded);
    }

    return (
        <div className={'rma-page-items'}>
            <Card 
                isLoading={isLoading}
                toolbar={{
                    title: <div className="rma-page-items-title-container">
                        <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('NEW_ITEMS', pageScope)}</FontBody1>
                    </div>,
                }}
                isExpandable={true}
                isExpanded={isExpanded}
                expandCallback={onExpandClick}
                spacingVariant={CARD_SPACING_VARIANT.SMAll}
            >
                
                <div className="rma-page-items-table">
                    <Table columns={[
                        {content: '', width: {value: 16, type: 'px'}},
                        {content: getTranslation('ITEM', 'dashboard-create-rma'), width: {value: 6, type: 'fr'}},
                        {content: getTranslation('QUANTITY', pageScope), width: {value: 120, type: 'px'}},
                        {content: getTranslation('PRICE', pageScope), width: {value: 2, type: 'fr'}},
                        {content: getTranslation('PC_RESOLUTION', pageScope), width: {value: 3, type: 'fr'}},
                        {content: '', width: {value: 80, type: 'px'}},
                        {content: '', width: {value: 36, type: 'px'}},
                    ]}
                        spacingVariant={TABLE_SPACING_VARIANT.SMAll}
                    >
                        {customerCaseStore?.exchangesList && customerCaseStore?.exchangesList.map((exchangeStore, index) => {

                            const resolutionDisplayName = exchangeStore.productCaseId
                                ? customerCaseStore.findPolicyRuleStoreByProductCaseId(exchangeStore.productCaseId)?.displayName ?? ''
                                : "Product exchange";

                            return <TableRow
                                key={`exchanges-list-item-${index}`}
                                cells={[
                                null,
                                <div className={'original-item-cell'}>
                                    {exchangeStore.image && <MediaWithPlaceholder variant={MEDIA_VARIANTS.XS} alt={exchangeStore.name} enlargeSrc={exchangeStore.image} src={exchangeStore.image} />}
                                    <div className={"original-item-product-title"}>
                                        <TextTruncate>
                                            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{exchangeStore.name}</FontBody2>
                                        </TextTruncate>
                                        <TextTruncate>
                                            <FontBody2 color={FONT_COLOR.NEUTRAL3}>{exchangeStore.variantTitle}</FontBody2>
                                        </TextTruncate>
                                        <TextTruncate>
                                            <FontBody2 color={FONT_COLOR.NEUTRAL3}>{exchangeStore.sku}</FontBody2>
                                        </TextTruncate>
                                    </div>
                                </div>,
                                <div className={'original-item-cell'}>
                                    <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                                       {`${exchangeStore.quantity}`}
                                    </FontBody2>
                                </div>,
                                <div className={'original-item-cell'}>
                                    {exchangeStore.showPriceBreakdown ? (
                                        <Tooltip
                                            content={
                                                <div className="rma-item-balance-tooltip">
                                                    {exchangeStore.appliedDiscount && (
                                                        <RmaNotZeroMoneyAmount
                                                            title={
                                                                getTranslation('NEW_ITEM_APPLIED_DISCOUNT', pageScope,
                                                                    exchangeStore.discounts
                                                                        ? [exchangeStore.discounts?.map((discount) => {
																			if (typeof discount === 'string') {
																				return `"${discount}"`;
																			} else {
																				return `"${discount.code}"`;
																			}
	                                                                    }).join(', ')]
                                                                        : []
                                                                )
                                                            }
                                                            moneyDto={exchangeStore.appliedDiscount}
                                                            color={FONT_COLOR.NEUTRAL_WHITE}
                                                        />
                                                    )}
                                                    {exchangeStore.bxgyDiscountAdjustment && (
                                                        <RmaNotZeroMoneyAmount
                                                            title={getTranslation('NEW_ITEM_BXGY_DISCOUNT_ADJUSTMENT', pageScope)}
                                                            moneyDto={exchangeStore.bxgyDiscountAdjustment}
                                                            color={FONT_COLOR.NEUTRAL_WHITE}
                                                        />
                                                    )}
                                                </div>
                                            }
                                            placement={TOOLTIP_PLACEMENTS.TOP}
                                            variant={TOOLTIP_VARIANTS.INFO}
                                        >
                                            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                                                <Currency currencyCode={customerCaseStore.paymentCurrencyCode} amount={(exchangeStore.getPriceByCurrency(customerCaseStore.paymentCurrencyCode) ?? 0)} />
                                            </FontBody2>
                                        </Tooltip>
                                    ) : (
                                        <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                                            <Currency currencyCode={customerCaseStore.paymentCurrencyCode} amount={(exchangeStore.getPriceByCurrency(customerCaseStore.paymentCurrencyCode) ?? 0)} />
                                        </FontBody2>
                                    )}
                                </div>,
                                <div className={'policy-rule-cell'}>
                                    {resolutionDisplayName && (<>
                                        <Icon Component={IconReturnNotRefundExchange} size={ICON_SIZE.SMALL} />
                                        <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                                            <TextTruncate>{resolutionDisplayName}</TextTruncate>
                                        </FontBody2>
                                    </>)}
                                </div>
                            ]} />
                        })}
                    </Table>
                </div>
            </Card>
        </div>
    );
});

export default RmaPageNewItemsCard;